import React from 'react'
import { Imagem } from './style'

import image from '../../assets/HEADER.png'

export default function(){
    return (
        <Imagem src={image} className="img-fluid" />
    )
}